/**
 * 区分 goalScopeType（goals.goal_scope_type）
 * 出典：仕様書 7 章
 */
export const GOAL_SCOPE_TYPE_VALUES = ['organization', 'personal'] as const;

export type GoalScopeType = (typeof GOAL_SCOPE_TYPE_VALUES)[number];

export const GOAL_SCOPE_TYPE_LABELS: Readonly<Record<GoalScopeType, string>> = {
  organization: '組織',
  personal: '個人',
};
